<script>
  import { onMount } from 'svelte';
  import { json, csv } from 'd3-fetch';
  import { geocoder } from './../../geocoder.js';
  import { CITY_TILESET_ID } from './../../constants.js';

  const MapboxToken =
    'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

  onMount(() => {
    geocoder.addTo('#geocoder');
    geocoder.setPlaceholder('Enter an address in L.A. County.');
  });

  // geocoder
  /**
   * @param {{ center: any; }} r
   */
  async function getCity(r) {

    //// this function takes the coordinates of the geocoder results and looks up at our shape your LA city tileset to return a city name
    let coord = r.center;
    let tileApi = `https://api.mapbox.com/v4/${CITY_TILESET_ID}/tilequery/${coord[0]},${coord[1]}.json?&limit=7&access_token=${MapboxToken}`;
    let tileFeed = await json(tileApi);

    if (tileFeed.features.length > 0) {

      // if the city is a match, it's matched and stored in the city variable
      let area = tileFeed.features[0].properties.id;
      city = area;
      error = false;
    } else {
      city = undefined;
      error = true;
    }
    // console.log("city: ",city)
    return city;
  }

  // look up
  const url = new URL('./../../../assets/data/blockparty.csv', import.meta.url);

  async function lookup(c) {

    if (c != undefined){
        const data = await csv(url);
        let d = data.find((item) => item.city.trimEnd() == c);
        // console.log(d);

        info = d;
    }

  }

  const cityDict =
  {
    "Unincorporated": "unincorporated area of Los Angeles county",
    "Industry" : "City of Industry"
  }

  const cityCleaner=(c)=>{

    let cleanName = cityDict[`${city}`] == undefined ? c : cityDict[`${city}`]

    return cleanName
    
  }
  // by default city is set to Los Angeles
  $: city = "Los Angeles";

  // error is true if the query cannot find a matching city in los angeles tileset and adds an error msg
  $: error = false;
  
  // info is filled out when the city is a match on the look up function 
  $: info = {};

  // by default we look up Los Angeles
  lookup("Los Angeles")

  geocoder.on('result', function (e) {

    // results from geocoder runs two async functions - getCity then lookup
    let result = e.result;
    getCity(result).then((c) => lookup(c));
  });
</script>

<div class="text-wrapper">
  <h2>Planning for a block party in your neighborhood</h2>
  <p>
    Enter your address below to find out what it takes to throw a block party.
  </p>
</div>
<div class="coder-wrapper">
  <div id="geocoder" class="geocoder" />

  <!-- If error is true because city could not be found on tileset. Otherwise it adds the blue banner with city name on it -->
  <p class:error={error==true}
     class:city={city != undefined}>
    {#if error == true}
      Please choose a place in Los Angeles County 
    {:else if city != undefined}
    {cityCleaner(city)}  
    {/if}
  </p>
</div>

<!-- If the city is in los angeles county, what gets rendered rely on the status column first -->
<div id="info-wrapper">
  {#if error == false}
    <div class="info">
      {#if info.status == 'yes'}
        <ul>
          <li>
            <h4>Where do I start?</h4>
            <p class="answer">
              In {cityCleaner(city)}, you will need to get in touch with the {info.department} and
              ask for a {info.permit_name}{#if info.days !== 'N/A' && info.days !== 'No response'}, at least {info.days} in advance{/if}. {#if info.multiple_permits == 'Yes'}You
              may need more than one permit for your party.{/if}
            </p>
          </li>
          <li>
            <h4>How can I contact the department?</h4>
            <p class="answer">
              You can contact them {info.how}. More information can be
              found <a target="_blank" href={info.website}>here</a>.
            </p>
          </li>
          <li>
            <h4>How much will it cost?</h4>
            <p>{#if info.permit_fee.includes("$")}The permit will cost {:else if info.permit_fee.includes("assessed")} The price of the permit will be{/if} {info.permit_fee}.</p>
          </li>
          <li>
            <h4>Are there any additional costs to consider?</h4>
            <p class="answer">
                {#if info.additional_costs != 'No response'}{info.additional_costs}.{/if} 
                {#if info.additional_costs != 'No'}{info.additional_costs_notes}{/if}
            </p>
          </li>
          <li>
            <h4>Will the city help me out?</h4>
            <p class="answer">{info.subsidized}</p>
          </li>
        </ul>
      {:else if info.status == "Not allowed" }
        <p class="top">
          Block parties are not allowed in {cityCleaner(city)}.
        </p>
      {:else}
      <p class="top">
        {info.status}
      </p>
      {/if}
    </div>
  {/if}
</div>
